"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-monitor/schedule.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-monitor%2Fschedule.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.runStatusToJSON = exports.runStatusFromJSON = exports.DayOfMonthSchedule = exports.Schedule = exports.RunStatus = void 0;
const protobufPackage = 'com.step.creditmonitor.schedule.proto';
/**
 * The status of a scheduled credit pull run.
 */
var RunStatus;
(function (RunStatus) {
    RunStatus["INVALID_RUN_STATUS"] = "INVALID_RUN_STATUS";
    /**
     * SCHEDULED - credit pull is scheduled to run.
     */
    RunStatus["SCHEDULED"] = "SCHEDULED";
    /**
     * PENDING - credit pull is in progress.
     */
    RunStatus["PENDING"] = "PENDING";
    /**
     * COMPLETED - credit pull is completed.
     */
    RunStatus["COMPLETED"] = "COMPLETED";
    /**
     * SKIPPED - credit pull was skipped.
     */
    RunStatus["SKIPPED"] = "SKIPPED";
    RunStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RunStatus || (exports.RunStatus = RunStatus = {}));
function createBaseSchedule() {
    return { dayOfMonth: undefined };
}
exports.Schedule = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.dayOfMonth)) {
            message.dayOfMonth = exports.DayOfMonthSchedule.fromJSON(object.dayOfMonth);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dayOfMonth !== undefined) {
            obj.dayOfMonth = exports.DayOfMonthSchedule.toJSON(message.dayOfMonth);
        }
        return obj;
    },
    create(base) {
        return exports.Schedule.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSchedule();
        message.dayOfMonth = (object.dayOfMonth !== undefined && object.dayOfMonth !== null)
            ? exports.DayOfMonthSchedule.fromPartial(object.dayOfMonth)
            : undefined;
        return message;
    },
};
function createBaseDayOfMonthSchedule() {
    return { dayOfMonth: 0 };
}
exports.DayOfMonthSchedule = {
    fromJSON(object) {
        const message = {
            dayOfMonth: isSet(object.dayOfMonth) ? globalThis.Number(object.dayOfMonth) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dayOfMonth !== 0) {
            obj.dayOfMonth = Math.round(message.dayOfMonth);
        }
        return obj;
    },
    create(base) {
        return exports.DayOfMonthSchedule.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDayOfMonthSchedule();
        message.dayOfMonth = object.dayOfMonth ?? 0;
        return message;
    },
};
function runStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_RUN_STATUS':
            return RunStatus.INVALID_RUN_STATUS;
        case 1:
        case 'SCHEDULED':
            return RunStatus.SCHEDULED;
        case 2:
        case 'PENDING':
            return RunStatus.PENDING;
        case 3:
        case 'COMPLETED':
            return RunStatus.COMPLETED;
        case 4:
        case 'SKIPPED':
            return RunStatus.SKIPPED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RunStatus.UNRECOGNIZED;
    }
}
exports.runStatusFromJSON = runStatusFromJSON;
function runStatusToJSON(object) {
    switch (object) {
        case RunStatus.INVALID_RUN_STATUS:
            return 'INVALID_RUN_STATUS';
        case RunStatus.SCHEDULED:
            return 'SCHEDULED';
        case RunStatus.PENDING:
            return 'PENDING';
        case RunStatus.COMPLETED:
            return 'COMPLETED';
        case RunStatus.SKIPPED:
            return 'SKIPPED';
        case RunStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.runStatusToJSON = runStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=schedule.js.map